import React from 'react'
import styles from './css/fillStyle.module.css'

export const MEMO_BOX_WIDTH = 120
export const MEMO_BOX_HEIGHT = 52

function MemoLayer({ memos, secondFrom, secondTo, secondToXPosition, height, width, topSpace }) {
	const elements = []

	for (const memo of memos) {
		const relSec = memo.second - secondFrom
		if (relSec < 0 || relSec > (secondTo - secondFrom)) continue

		const x = secondToXPosition(relSec)
		const y = topSpace

		// 備忘貼紙標記起始點虛線
		// elements.push(
		// 	<line
		// 		key={`mline_${memo.memoId}`}
		// 		x1={x} y1={y + MEMO_BOX_HEIGHT}
		// 		x2={x} y2={height}
		// 		stroke="#66bb6a"
		// 		strokeWidth={1}
		// 		strokeDasharray="5,3"
		// 	/>
		// )

		elements.push(
			<rect
				key={`mrect_${memo.memoId}`}
				x={x}
				y={y}
				width={MEMO_BOX_WIDTH}
				height={MEMO_BOX_HEIGHT}
				fill="#feff9c"
				stroke="#FFDE21"
				strokeWidth={1.5}
				rx={4}
				fillOpacity={0.8}
			/>
		)

		const lines = memo.text.split('\n').slice(0, 3)
		lines.forEach((line, i) => {
			const display = line.length > 14 ? line.substring(0, 14) + '…' : line
			elements.push(
				<text
					key={`mtext_${memo.memoId}_${i}`}
					x={x + 5}
					y={y + 15 + i * 13}
					fontSize={16}
					fill="#1b5e20"
					fontFamily="sans-serif"
				>
					{display}
				</text>
			)
		})
	}

	return (
		<svg
			width={width}
			height={height}
			className={styles.fill}
			style={{ pointerEvents: 'none' }}
		>
			{elements}
		</svg>
	)
}

export default MemoLayer
